import React from "react";
import {
  any,
  arrayOf,
  bool,
  func,
  node,
  object,
  oneOf,
  string
} from "prop-types";

import componentSizes from "../../constants/componentSizes";
import Field from "../Field";
import Combobox from "./components/Combobox";

const autocompleteOptions = {
  list: "list",
  none: "none"
};

const ComboboxField = React.forwardRef(
  (
    {
      autocomplete,
      className,
      defaultValue,
      disabled,
      error,
      helper,
      id,
      inputOptions,
      isValid,
      label,
      labelIdentity,
      name,
      onChange,
      onOptionSelect,
      options,
      required,
      size,
      value,
      ...passThroughProps
    },
    ref
  ) => (
    <Field
      ref={ref}
      className={className}
      error={error}
      helper={helper}
      id={id}
      isValid={isValid}
      label={label}
      {...passThroughProps}
    >
      <Combobox
        autocomplete={autocomplete}
        defaultValue={defaultValue}
        disabled={disabled}
        id={id}
        isValid={isValid}
        labelIdentity={labelIdentity}
        name={name}
        onChange={onChange}
        onOptionSelect={onOptionSelect}
        options={options}
        required={required}
        size={size}
        value={value}
        {...inputOptions}
      />
    </Field>
  )
);

ComboboxField.propTypes = {
  autocomplete: oneOf(Object.values(autocompleteOptions)),
  className: string,
  // eslint-disable-next-line react/require-default-props
  defaultValue: string,
  disabled: bool,
  error: string,
  helper: node,
  id: string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  inputOptions: object,
  isValid: bool,
  label: string.isRequired,
  // eslint-disable-next-line react/require-default-props
  labelIdentity: func,
  name: string,
  onChange: func,
  onOptionSelect: func,
  options: arrayOf(any).isRequired,
  required: bool,
  size: oneOf([componentSizes.SM, componentSizes.MD, componentSizes.LG]),
  // eslint-disable-next-line react/require-default-props
  value: string
};

ComboboxField.defaultProps = {
  autocomplete: autocompleteOptions.list,
  className: "",
  disabled: false,
  error: "",
  helper: "",
  inputOptions: {},
  isValid: true,
  name: "",
  onChange: () => {},
  onOptionSelect: () => {},
  required: false,
  size: componentSizes.MD
};

export default ComboboxField;
